import { useState } from 'react';
import api from '../../../services/api';

/**
 * Owns coupon entry/validation state for lab checkout.
 */
export default function useLabCoupon(lab, basePrice) {
  const [couponCode, setCouponCode] = useState('');
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [couponError, setCouponError] = useState('');
  const [couponLoading, setCouponLoading] = useState(false);

  const handleApplyCoupon = async () => {
    if (!couponCode.trim() || !lab) return;
    setCouponError('');
    setCouponLoading(true);
    try {
      const result = await api.validateCoupon(couponCode, basePrice, lab.id);
      if (result.valid) {
        setAppliedCoupon({ code: couponCode.toUpperCase(), label: result.discountLabel || `-$${result.discountAmount}` });
        setCouponCode('');
      } else {
        setCouponError(result.message || 'Invalid coupon code.');
      }
    } catch {
      setCouponError('Failed to apply coupon.');
    } finally {
      setCouponLoading(false);
    }
  };

  return {
    couponCode, setCouponCode,
    appliedCoupon, setAppliedCoupon,
    couponError, couponLoading,
    handleApplyCoupon,
  };
}
